// Open and close move layout, so they take the standard curve: the emphasized curves put 90% of the travel
// in the first 100ms or half of it in the last 15ms, which snaps. The swap-out only fades, so its quick exit is fine.
const STANDARD = 'cubic-bezier(0.2, 0, 0, 1)'
const EMPHASIZED_ACCELERATE = 'cubic-bezier(0.3, 0, 0.8, 0.15)'

export const NAV_MOTION = Object.freeze({
  open: `280ms ${STANDARD}`,
  close: `220ms ${STANDARD}`,
  swapOut: `100ms ${EMPHASIZED_ACCELERATE}`,
  swapIn: `220ms ${STANDARD}`,
})
